import '../Styles/Dashboard.css';
import '../Styles/OtpModal.css';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axiosProvider2 from '../AxiosProvider2';

function CashBack(props) {
  const { t, i18n } = useTranslation();

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpInput, setOtpInput] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [otpError, setOtpError] = useState("");


  const fireOtp = async () => {
    try {
      setIsSending(true);
      await axiosProvider2.post(
        `agent/users/${parseInt(localStorage.getItem("customerId"))}/fire-otp`,
        {},
        {
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("token")}`
          }
        }
      );
      setShowOtpModal(true);
    } catch (err) {
      alert(t("login.failedToSendOtp")); // or use toast
    } finally {
      setIsSending(false);
    }
  };

  const handleOtpConfirm = async () => {
    if (!otpInput.trim()) return;
    setIsSubmitting(true);

    try {
      const resss = await props.createOrder({
        applyOffer: true,
        applyOfferOtp: otpInput
      });
      console.log(resss)



      // only runs if success
      setOtpInput("");
      setShowOtpModal(false);
      props.setModal(false);

    } catch (err) {
      if (err?.response?.data?.error) {
        setOtpError(
          i18n.language === "ar"
            ? "رمز التحقق غير صحيح"
            : "Invalid verification code"
        );
      } else {
        setOtpError(
          i18n.language === "ar"
            ? "حدث خطأ ما"
            : "Something went wrong"
        );
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleContinueWithOffer = async () => {
    // await fireOtp();
    // props.setModal(false);
    props.setSubmitLoading(false);
    props.setModal(false);
    props.createOrder({ applyOffer: true });
  };

  const handleContinueWithoutOffer = () => {
    props.setSubmitLoading(false);
    props.setModal(false);
  
  };

  return (
    <>
      {/* 🎁 Gift Modal */}
      <div className="modalOverlay" onClick={() => props.setModal(false)}></div>
      <div className="modal-content" style={{ height: "auto", width: "40vw", minWidth: "337px", paddingTop: "2em", position: "fixed" }}>
        <p className='alrt'>
          {i18n.language === "ar"
            ? "سيتم أضافة مبلغ الهدية لمحفظتك عند استلامك للطلب"
            : "Gift amount will be added to your wallet after receiving your order"}
        </p>

        {props.button && (
          <div className='modalBtns' style={{ marginTop: "2em" }}>
            <button
              onClick={handleContinueWithOffer}
              className='del'
              disabled={isSending}
            >
              {isSending ? t("sending") : t("menu.continue")}
            </button>
            {/* <button
              onClick={handleContinueWithoutOffer}
              className='cls'
            >
              {t("profile.cancel")}
            </button> */}
          </div>
        )}
      </div>

      {/* 🔐 OTP Modal */}

      {showOtpModal && (
        <>
          <div className="otp-modal-overlay" onClick={() => setShowOtpModal(false)}></div>
          <div className="otp-modal-content">
            <p className="otp-modal-title">
              {i18n.language === "ar"
                ? "رمز التحقق"
                : "OTP Verification"}
            </p>
            <p className="otp-modal-subtitle">
              {i18n.language === "ar"
                ? `من فضلك أدخل رمز التحقق الذي أُرسل إلى ${localStorage.getItem("customerPhone")}`
                : `Please enter the OTP sent to ${localStorage.getItem("customerPhone")}`}
            </p>
            <input
              type="text"
              value={otpInput}
              onChange={(e) => setOtpInput(e.target.value)}
              placeholder={t("Login.enterOtp") || "Enter OTP"}
              className="otp-input"
            />
            {otpError && (
              <p className="otp-error-text" style={{ color: "red", marginTop: "5px" }}>
                {otpError}
              </p>
            )}
            <div className="otp-modal-buttons">
              <button
                onClick={handleOtpConfirm}
                className="otp-confirm-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? t("loading") : t("Login.confirm")}
              </button>
              <button
                onClick={() => {
                  setShowOtpModal(false);
                  setOtpInput("");
                  props.setSubmitLoading(false);
                  props.createOrder({ applyOffer: false });
                }}
                className="otp-cancel-btn"
              >
                {t("continueWithoutOffer")}
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default CashBack;